import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from "react";
import CustomCard from "../../UI/CustomCard/CustomCard";
import FilterService from "../../../Services/Filter.service";
import useService from "../../Hooks/useService";
import InfoItems from "../../UI/InfoItems/InfoItems";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import BooleanDisplay from "../../UI/BooleanDisplay/BooleanDisplay";
const labelMappings = {
    advisors: "Faculty",
    applicationAdmitStatus: "Admission Status",
    applicationAgeLessThanDays: "Application Age Less Than (Days)",
    applicationAgeMoreThanDays: "Application Age More Than (Days)",
    applicationLocations: "Application Locations",
    applicationResidencyStatus: "Residency Application Status",
    applicationStatuses: "Application Status",
    applicationStudentLoadIntent: " Application Load Intent",
    applicationStudentType: "Application  Type",
    applicationTerms: "Terms Application",
    applicationTypes: "Application Types",
    city: "City",
    coaches: "Coaches",
    concentrations: "Concentrations",
    courseSections: "Course Sections",
    courseSuccessScoringGroups: "Course Success Scoring Groups",
    courses: "Courses",
    customStudentList: "Custom Student List",
    daysSinceSubmittedFormMax: "Days Since Submitted Form Max",
    daysSinceSubmittedFormMin: "Days Since Submitted Form Min",
    degrees: "Degrees",
    ethnicities: "Ethnicities",
    excludeAnyTags: "Exclude Any Tags",
    gender: "Gender",
    hasOpenAlerts: "Has Open Alerts",
    highSchoolGraduationType: "High School Graduation Type",
    highSchoolTranscriptDateFrom: "High School Transcript Date From",
    highSchoolTranscriptDateTo: "High School Transcript Date To",
    highSchoolTranscriptStatus: "High School Transcript Status",
    highSchoolTranscriptType: "High School Transcript Type",
    highSchoolYearAttendedFrom: "High School Year Attended End From",
    highSchoolYearAttendedStartFrom: "High School Year Attended Start From",
    highSchoolYearAttendedStartTo: "High School Year Attended Start To",
    highSchoolYearAttendedTo: "High School Year Attended End To",
    highSchools: "High Schools",
    holds: "Holds",
    importProcesses: "Import Processes",
    inPersonsCaseload: "In Person's Caseload",
    includeAnyTags: "Include Any Tags",
    includesCurrentTermsForCourses: "Includes Current Terms For Courses",
    intendedStartTerms: "Intended Start Terms",
    interestedDepartments: "Interested Departments",
    isFirstGeneration: "Is First Generation",
    isMinority: "Is Minority",
    isVeteran: "Is Veteran",
    anticipatedGraduationDateFrom: "Anticipated Graduation Date From",
    anticipatedGraduationDateTo: "Anticipated Graduation Date To",
    lastAssignmentSubmittedLessThanDays: "Last Assignment Submitted Less Than (Days)",
    lastAssignmentSubmittedMoreThanDays: "Last Assignment Submitted More Than (Days)",
    lastKEAgeMoreThanDays: "Last KE Age More Than (Days)",
    locations: "Campuses",
    majors: "Majors",
    maxAge: "Max Age",
    maxCumulativeCreditHours: "Max Cumulative Credit Hours",
    maxCumulativeGpa: "Max Cumulative GPA",
    maxHighSchoolEndDate: "Max High School End Date",
    maxHighSchoolGPA: "Max High School GPA",
    maxHighSchoolStartDate: "Max High School Start Date",
    maxMajorGpa: "Max Major GPA",
    minAge: "Min Age",
    minCumulativeCreditHours: "Min Cumulative Credit Hours",
    minCumulativeGpa: "Min Cumulative GPA",
    minHighSchoolEndDate: "Min High School End Date",
    minHighSchoolGPA: "Min High School GPA",
    minHighSchoolStartDate: "Min High School Start Date",
    minMajorGpa: "Min Major GPA",
    minors: "Minors",
    noApplicationAdmitStatus: "No Application Admit Status",
    noApplicationLocations: "No Application Locations",
    noApplicationResidencyStatus: "No Application Residency Status",
    noApplicationStudentLoadIntent: "No Application Load Intent",
    noApplicationStudentType: "No Application Type",
    noApplicationTypes: "No Application Types",
    noConcentrations: "No Concentrations",
    noDegrees: "No Degrees",
    noEthnicities: "No Ethnicities",
    noHighSchoolGraduationType: "No High School Graduation Type",
    noHighSchoolTranscriptStatus: "No High School Transcript Status",
    noHighSchoolTranscriptType: "No High School Transcript Type",
    noHighSchools: "No High Schools",
    noHolds: "No Holds",
    noIntendedStartTerms: "No Intended Start Terms",
    noInterestedDepartments: "No Interested Departments",
    interestedPrograms: "Interested Programs",
    noInterestedPrograms: "No Interested Programs",
    noMajors: "No Majors",
    noMinors: "No Minors",
    noPrograms: "No Programs",
    noProspectSources: "No Prospect Sources",
    noRaces: "No Races",
    noRegistrationTerms: "No Registration Terms",
    noSearchFilterSubmittedForms: "No Search Filter Submitted Forms",
    noSpecializations: "No Specializations",
    noStudentStatuses: "No Student Statuses",
    noStudentTypes: "No Student Types",
    noSubmittedFormsAnswerDepartmentInterests: "No Submitted Forms Answer Department Interests",
    noSubmittedFormsAnswerIntendedStartTerms: "No Submitted Forms Answer Intended Start Terms",
    noSubmittedFormsAnswerInterestedPrograms: "No Submitted Forms Answer Interested Programs",
    noTags: "No Tags",
    noVeteranTypes: "No Veteran Types",
    pipelineStaff: "Pipeline Staff",
    pipelines: "Pipelines",
    programs: "Programs",
    prospectSources: "Prospect Sources",
    races: "Races",
    registrationTerms: "Registration Terms",
    searchFilterSubmittedForms: "Search Filter Submitted Forms",
    searchFollowersOnly: "Search Followers Only",
    specializations: "Specializations",
    stages: "Stages",
    state: "State",
    studentStatuses: "Student Statuses",
    studentTypes: "Student Types",
    submittedFormsAnswerDepartmentInterests: "Submitted Forms Answer Department Interests",
    submittedFormsAnswerIntendedStartTerms: "Submitted Forms Answer Intended Start Terms",
    submittedFormsAnswerInterestedPrograms: "Submitted Forms Answer Interested Programs",
    tags: "Tags",
    termSuccessScoringGroups: "Term Success Scoring Groups",
    terms: "Terms",
    veteranTypes: "Veteran Types",
    zipCode: "Zip Code",
};
const mapObjectToLabelValue = (obj, filterLabel) => {
    const result = [];
    let noTags = false;
    let tags = false;
    const handleArraySpecialCases = (prop, value, label) => {
        switch (prop) {
            case "applicationStudentType":
            case "noApplicationStudentType":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((type) => type.name).join(", ")
                        : null,
                };
            case "applicationLocations":
            case "noApplicationLocations":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((location) => location.name).join(", ")
                        : null,
                };
            case "races":
            case "noRaces":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((race) => race.name).join(", ")
                        : null,
                };
            case "degrees":
            case "noDegrees":
            case "highSchools":
            case "noHighSchools":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((degree) => degree.fullName).join(", ")
                        : null,
                };
            case "advisors":
            case "coaches":
            case "inPersonsCaseload":
            case "pipelineStaff":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((person) => person.fullName).join(", ")
                        : null,
                };
            case "customStudentList":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value) ? value.join(", ") : null,
                };
            case "registrationTerms":
            case "noRegistrationTerms":
            case "applicationTerms":
            case "terms":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value
                            .map((term) => term.displayName)
                            .join(", ")
                        : null,
                };
            case "holds":
            case "noHolds":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((hold) => hold.name).join(", ")
                        : null,
                };
            case "locations":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((location) => location.name).join(", ")
                        : null,
                };
            case "courses":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((course) => course.fullName).join(", ")
                        : null,
                };
            case "courseSections": {
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value
                            .map((courseSection) => courseSection.name)
                            .join(", ")
                        : null,
                };
            }
            case "applicationStudentLoadIntent":
            case "noApplicationStudentLoadIntent":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value
                            .map((loadIntent) => loadIntent.name)
                            .join(", ")
                        : null,
                };
            case "applicationResidencyStatus":
            case "noApplicationResidencyStatus":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value
                            .map((residencyStatus) => residencyStatus.name)
                            .join(", ")
                        : null,
                };
            case "applicationAdmitStatus":
            case "noApplicationAdmitStatus":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value
                            .map((admitStatus) => admitStatus.name)
                            .join(", ")
                        : null,
                };
            case "veteranTypes":
            case "noVeteranTypes":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value
                            .map((veteranType) => veteranType.name)
                            .join(", ")
                        : null,
                };
            case "ethnicities":
            case "noEthnicities":
                return {
                    label: label[prop] || prop,
                    value: value.map((ethnicity) => ethnicity.name).join(", "),
                };
            case "programs":
            case "submittedFormsAnswerInterestedPrograms":
            case "noPrograms":
            case "noSubmittedFormsAnswerInterestedPrograms":
            case "interestedPrograms":
            case "noInterestedPrograms":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((program) => program.fullName).join(", ")
                        : null,
                };
            case "stages":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((stage) => stage.name).join(", ")
                        : null,
                };
            case "studentTypes":
            case "noStudentTypes":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value
                            .map((studentType) => studentType.name)
                            .join(", ")
                        : null,
                };
            case "studentStatuses":
            case "noStudentStatuses":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value
                            .map((studentStatus) => studentStatus.name)
                            .join(", ")
                        : null,
                };
            case "termSuccessScoringGroups":
            case "courseSuccessScoringGroups":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((group) => group.name).join(", ")
                        : null,
                };
            case "tags":
            case "noTags":
                if (prop === "tags" && value.length) {
                    tags = true;
                }
                if (prop === "noTags" && value.length) {
                    noTags = true;
                }
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((tag) => tag.name).join(", ")
                        : null,
                };
            case "majors":
            case "noMajors":
            case "minors":
            case "noMinors":
            case "concentrations":
            case "noConcentrations":
            case "specializations":
            case "noSpecializations":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value
                            .map((major) => `${major.code} ${major.name}`)
                            .join(", ")
                        : null,
                };
            case "prospectSources":
            case "noProspectSources":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((source) => source.name).join(", ")
                        : null,
                };
            case "searchFilterSubmittedForms":
            case "noSearchFilterSubmittedForms":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((form) => form.title).join(", ")
                        : null,
                };
            case "highSchoolTranscriptStatus":
            case "noHighSchoolTranscriptStatus":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value
                            .map((status) => status.name)
                            .join(", ")
                        : null,
                };
            case "highSchoolTranscriptType":
            case "noHighSchoolTranscriptType":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value
                            .map((type) => type.name)
                            .join(", ")
                        : null,
                };
            case "highSchoolGraduationType":
            case "noHighSchoolGraduationType":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value
                            .map((type) => type.name)
                            .join(", ")
                        : null,
                };
            case "applicationStatuses":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value
                            .map((status) => status.applicationStatusName)
                            .join(", ")
                        : null,
                };
            case "applicationTypes":
            case "noApplicationTypes":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((type) => type.name).join(", ")
                        : null,
                };
            case "interestedDepartments":
            case "noInterestedDepartments":
            case "submittedFormsAnswerDepartmentInterests":
            case "noSubmittedFormsAnswerDepartmentInterests":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((department) => department.name).join(", ")
                        : null,
                };
            case "intendedStartTerms":
            case "noIntendedStartTerms":
            case "submittedFormsAnswerIntendedStartTerms":
            case "noSubmittedFormsAnswerIntendedStartTerms":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((term) => term.name).join(", ")
                        : null,
                };
            case "pipelines":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((pipeline) => pipeline.name).join(", ")
                        : null,
                };
            case "importProcesses":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((process) => process.title).join(", ")
                        : null,
                };
            case "state":
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value)
                        ? value.map((state) => state.name).join(", ")
                        : null,
                };
            default:
                return {
                    label: label[prop] || prop,
                    value: Array.isArray(value) ? value.join(", ") : value,
                };
        }
    };
    // @ts-expect-error ts-2345 - Case where prop is not keyof StudentSearch is handled
    Object.keys(obj).forEach((prop) => {
        if (typeof obj[prop] === "object" && Array.isArray(obj[prop])) {
            result.push(handleArraySpecialCases(prop, obj[prop], filterLabel));
        }
        if (typeof obj[prop] === "boolean") {
            if (!(prop === "searchFollowersOnly" && !obj[prop]) &&
                !(prop === "includesCurrentTermsForCourses") &&
                !(prop === "excludeAnyTags" && !noTags) &&
                !(prop === "includeAnyTags" && !tags)) {
                result.push({
                    label: filterLabel[prop] || prop,
                    value: _jsx(BooleanDisplay, { val: obj[prop] }),
                });
            }
        }
        if (typeof obj[prop] === "string") {
            result.push({
                label: filterLabel[prop] || prop,
                value: obj[prop],
            });
        }
        if (typeof obj[prop] === "number") {
            result.push({
                label: filterLabel[prop] || prop,
                value: obj[prop].toString(),
            });
        }
    });
    return result;
};
const SharedFiltersCriteriaCard = ({ populationId, }) => {
    const [filterCriteriaState, loadFilterCriteria] = useService(FilterService.getStudentSearchValuesFromFilter);
    useEffect(() => {
        loadFilterCriteria(populationId);
    }, [populationId, loadFilterCriteria]);
    return (_jsx(ServiceResult, { state: filterCriteriaState, children: (filters) => (_jsx(_Fragment, { children: filters ? (_jsx(CustomCard, { className: "mb-3", title: "Filter Criteria", children: _jsx("div", { className: "card-body", children: _jsx(InfoItems, { items: mapObjectToLabelValue(filters.studentSearchValues, labelMappings).filter((result) => !(result.value === null ||
                            result.value === undefined ||
                            result.value === "")) }) }) })) : null })) }));
};
export default SharedFiltersCriteriaCard;
